import type { AnalyticsTrack } from "@/types/analytics";
import type { StrapiPricingPlan } from "@/types/strapi";

import { TrackEvent } from "@/util/tokens/track_event_util";

export function getPricingPlanCtaTrack(
    plan: StrapiPricingPlan,
): AnalyticsTrack | undefined {
    switch (plan.Name) {
        case "Free":
            return TrackEvent.PRICING_FREE_PLAN_BUTTON_CLICKED;
        case "Pro":
        case "Team":
            return TrackEvent.PRICING_PAID_PLAN_BUTTON_CLICKED;
        case "Enterprise":
            return TrackEvent.PRICING_ENTERPRISE_CONTACT_US_BUTTON_CLICKED;
    }
}
